import $ from "jquery";
import {quickAlert} from "./alerts.ts";

export type AjaxFormOptions = {
    before?: ($form: JQuery<HTMLFormElement>) => void;
    success?: (response: any, $form: JQuery<HTMLFormElement>) => void;
    error?: (xhr: JQuery.jqXHR, $form: JQuery<HTMLFormElement>) => void;
    finally?: ($form: JQuery<HTMLFormElement>) => void;
    autoToast?: boolean;
    closeModalOnSuccess?: boolean;
};

export function bindAjaxForm(
    selector: string,
    opts: AjaxFormOptions = {}
): void {

    $(document).on('submit', selector, function (e) {
        e.preventDefault();

        const $form = $(this) as JQuery<HTMLFormElement>;
        opts.before?.($form);

        const formData = new FormData($form[0]);

        $.ajax({
            url: $form.attr('action')!,
            type: ($form.attr('method') || 'POST').toUpperCase(),
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')!
            }
        })
            .done((response) => {

                if (opts.autoToast !== false && response?.message) {
                    quickAlert(response.message, response.success ? 'success' : 'error');
                }

                if (opts.closeModalOnSuccess && response?.success) {
                    try { $.magnificPopup.close(); } catch (e) {}
                }

                opts.success?.(response, $form);
            })
            .fail((xhr) => {

                if (xhr.status === 422 && xhr.responseJSON?.errors) {
                    quickAlert(xhr.responseJSON.message || 'Validation error', 'error');
                } else {
                    quickAlert('Nastala neočakávaná chyba.', 'error');
                }

                opts.error?.(xhr, $form);
            })
            .always(() => {
                opts.finally?.($form);
            });
    });
}